const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ";

/**
 * Crockford ULID, 26 characters, sortable. Shared: the worker names rows with
 * it, the browser names a round for the offline queue (issue #118).
 */
export function newId(nowMs: number = Date.now()): string {
  const chars: string[] = new Array(26);
  let time = nowMs;
  for (let i = 9; i >= 0; i--) {
    chars[i] = ENCODING[time % 32] as string;
    time = Math.floor(time / 32);
  }
  const rand = crypto.getRandomValues(new Uint8Array(10));
  let value = 0n;
  for (const byte of rand) value = (value << 8n) | BigInt(byte);
  for (let i = 25; i >= 10; i--) {
    chars[i] = ENCODING[Number(value & 31n)] as string;
    value >>= 5n;
  }
  return chars.join("");
}
